/**
 * Please dont move that file outside of `app` folder,
 * that's a non-modify nuxt structure
 */
export default (to, from) => {
  if (to.hash) {
    const element = document.getElementById(to.hash.replace('#', ''));
    if (!element) return {
      x: 0,
      y: 0,
    };

    const HEADER_HEIGHT = 70;
    return {
      behavior: 'smooth',
      selector: to.hash,
      offset: {
        y: `-${HEADER_HEIGHT}px`
      }
    };
  }

  if (to.path === from.path) return;

  return {
    x: 0,
    y: 0,
  };
};
